import { bindable } from 'aurelia-framework';

class ProductIdsContainer {
  @bindable selectedAccount = null;
  @bindable selectedProduct = null;
  @bindable route = '#';
  loading = false;
  categories = null;
  /**
   * @param {AppErrorPublisher}     appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}           errorParser          Used for error parsing.
   * @param {ProductFeedsProducts}  productFeedsProducts To get the feed products.
   */
  constructor(appErrorPublisher, errorParser, productFeedsProducts) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productIdsErrorParser = errorParser.wrap();
    this._productFeedsProducts = productFeedsProducts;
  }
  selectedAccountChanged() {
    if (!this.loading && this.selectedProduct) {
      this._loadIds();
    }
  }
  selectedProductChanged() {
    if (!this.loading && this.selectedAccount) {
      this._loadIds();
    }
  }
  _loadIds() {
    this.loading = true;
    this._productFeedsProducts.getProductIds(
      this.selectedAccount.id,
      this.selectedProduct.id,
    )
    .then((ids) => {
      this.ids = ids;
    })
    .catch((error) => {
      const parsedError = this._productIdsErrorParser(
        error,
        'There was an error loading the IDs',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { ProductIdsContainer };
